export enum CarriagewayType {
  connectingCarriageway,
  entrySlipRoad,
  exitSlipRoad,
  mainCarriageway,
  parallelCarriageway
}



// WEBPACK FOOTER //
// ./src/app/models/enums/carriagewaytype.ts